var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcStreaming16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-streaming-16_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.879 5.878a3 3 0 0 0 0 4.243 1 1 0 1 1-1.415 1.414 5 5 0 0 1 0-7.071A1 1 0 0 1 5.88 5.878Zm4.242-1.414a1 1 0 0 1 1.415 0 5 5 0 0 1 0 7.071 1 1 0 1 1-1.415-1.414 3 3 0 0 0 0-4.243 1 1 0 0 1 0-1.414",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.757 3.757a6 6 0 0 0 0 8.485 1 1 0 1 1-1.414 1.414 8 8 0 0 1 0-11.313 1 1 0 1 1 1.414 1.414m8.486-1.414a1 1 0 0 1 1.414 0 8 8 0 0 1 0 11.313 1 1 0 0 1-1.414-1.414 6 6 0 0 0 0-8.485 1 1 0 0 1 0-1.414",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-streaming-16_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
})))));
export default SvgIcStreaming16;